export default {
      id: "delete-parameter-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#delete-parameter",
      toString: function () {
        return this.url;
      }
    }